module.exports = __webpack_public_path__ + "static/media/ge.035e3e14.mp3";